import { render } from "./Emoji.vue.js?vue&type=template&id=f01e266e!=!../../../vue-loader/dist/index.js??ruleSet[0]!./Emoji.vue?vue&type=template&id=f01e266e"
import script from "./Emoji.vue.js?vue&type=script&lang=js!=!../../../vue-loader/dist/index.js??ruleSet[0]!./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue.js?vue&type=script&lang=js!=!../../../vue-loader/dist/index.js??ruleSet[0]!./Emoji.vue?vue&type=script&lang=js"

import exportComponent from "../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__